import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, getApproval, getComplate, getPending } from "./dashboardAPI";

const initialState = {
  data: [],
  dataApproval: [],
  dataComplate: [],
  dataPending: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  statusParam: [],
  reasonParam: [],
  pageNoNew: 1,
  pageSizeNew: 10,
  totalRecordNew: 0,

};

export const fetchAll = createAsyncThunk(
  "dashboard/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);
export const fetchApproval = createAsyncThunk(
  "dashboard/fetchApproval",
  async (payload) => {
    const response = await getApproval(payload);
    return response.data;
  }
);
export const fetchComplate = createAsyncThunk(
  "dashboard/fetchComplate",
  async (payload) => {
    const response = await getComplate(payload);
    return response.data;
  }
);

export const fetchPending = createAsyncThunk(
  "dashboard/fetchPending",
  async (payload) => {
    const response = await getPending(payload);
    return response.data;
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNoNew = action.payload.pageNo;
        state.pageSizeNew = action.payload.pageSize;
        state.totalRecordNew = action.payload.totalRecord;
      })
      .addCase(fetchApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchApproval.fulfilled, (state, action) => {
        console.log(action, "action")
        state.loading = false;
        state.dataApproval = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchComplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchComplate.fulfilled, (state, action) => {
        state.loading = false;
        state.dataComplate = action.payload.data;
      })
      .addCase(fetchPending.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPending.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPending = action.payload.data;
      });
  },
});

export const { resetData, setSelected } = dashboardSlice.actions;

export const selectData = (state) => state.dashboard.data;
export const selectDataApproval = (state) => state.dashboard.dataApproval;
export const selectDataComplate = (state) => state.dashboard.dataComplate;
export const selectDataPending = (state) => state.dashboard.dataPending;
export const selectLoading = (state) => state.dashboard.loading;
export const selectError = (state) => state.dashboard.error;
export const selectSelected = (state) => state.dashboard.selected;
export const selectPageNo = (state) => state.dashboard.pageNo;
export const selectPageSize = (state) => state.dashboard.pageSize;
export const selectTotalRecord = (state) => state.dashboard.totalRecord;
export const selectPageNoNew = (state) => state.dashboard.pageNoNew;
export const selectPageSizeNew = (state) => state.dashboard.pageSizeNew;
export const selectTotalRecordNew = (state) => state.dashboard.totalRecordNew;

export default dashboardSlice.reducer;
